import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInfoGroupConfiguration, infoGroupConfigurationsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const INFO_GROUP_CONFIGURATION_MODULE = 'infoGroupConfiguration';

const dataObjectModule = getDataObjectsModule<IInfoGroupConfiguration>(infoGroupConfigurationsManager);
const searchModule = getSearchModule<IInfoGroupConfiguration>(infoGroupConfigurationsManager);

const infoGroupConfigurationModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(INFO_GROUP_CONFIGURATION_MODULE, infoGroupConfigurationModuleInstance);

export { INFO_GROUP_CONFIGURATION_MODULE };
